import {
  HIGHEST_OFFER_FETCH,
  USER_OFFER_POST,
  VALIDATE_OFFER,
  PENDING_OFFER_LIST_NEW,
  PENDING_OFFER_LIST,
  USER_OFFER_HISTORY_LIST,
  USER_OFFER_PENDING_LIST,
  USER_OFFER_ACCEPTED_LIST,
  ACCEPT_OFFER_REQUEST,
  USER_OFFER_DETAILS_FETCH,
  UPDATE_OFFER_USER,
  DELETE_OFFER_USER,
  FETCH_MAX_AMOUNT,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING,
  BID_VALIDATION,
  FETCH_BID_VALIDATION,
} from '../constants';

import error from '../utils/error';

const initialState = {
  highestOffer: {
    data: null,
    isFetch: false,
    error: null,
    status_code: 0,
    message: ''
  },
  submitOffer: {
    data: null,
    isSubmit: false,
    error: null,
    status_code: 0,
    message: ''
  },
  validateOffer: {
    data: null,
    isFetch: false,
    error: null,
    status_code: 0,
    message: ''
  },
  offerHistory: {
    dataOfferHistory: [],
    isFetch: false,
    error: null,
    status_code: 0,
    message: '',
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  offerDetails: {
    data: null,
    isFetch: false,
    error: null,
    status_code: 0,
    message: ''
  },
  offerPending: {
    dataOfferPending: [],
    isFetch: false,
    error: null,
    status_code: 0,
    message: '',
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  pendingListNew: {
    data: null,
    isFetch: false,
    error: null,
    status_code: 0,
    message: ''
  },
  pendingList: {
    dataPendingList: [],
    isFetch: false,
    error: null,
    status_code: 0,
    message: '',
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  acceptOffer: {
    data: null,
    isSubmit: false,
    error: null,
    status_code: 0,
    message: ''
  },
  updatedOffer: {
    status_code: 0,
    message: '',
    isSubmit: false,
    error: null
  },
  offerAccepted: {
    dataOfferAccepted: [],
    isFetch: false,
    error: null,
    status_code: 0,
    message: '',
    last_page: null,
    current_page: null,
    per_page: null,
    total: null
  },
  maxAmount: {
    data: null,
    isFetch: false,
    error: null,
    status_code: 0,
    message: ''
  },
  bidValidation: {
    data: null,
    isFetch: false,
    error: null,
    status_code : 0,
    message : ''
  }
}

const offerHistory = (state, {data: {data, last_page, current_page, per_page, total}, status_code}) => {
  let newState = {
    ...state,
    offerHistory: {
      ...state.offerHistory,
      isFetch: false,
      dataOfferHistory: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const offerPending = (state, {data: {data, last_page, current_page, per_page, total}, status_code}) => {
  let newState = {
    ...state,
    offerPending: {
      ...state.offerPending,
      isFetch: false,
      dataOfferPending: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const offerAccepted = (state, {data: {data, last_page, current_page, per_page, total}, status_code}) => {
  let newState = {
    ...state,
    offerAccepted: {
      ...state.offerAccepted,
      isFetch: false,
      dataOfferAccepted: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const pendingList = (state, {data: {data, last_page, current_page, per_page, total}, status_code}) => {
  let newState = {
    ...state,
    pendingList: {
      ...state.pendingList,
      isFetch: false,
      dataPendingList: [...data],
      status_code,
      last_page,
      current_page,
      per_page,
      total
    }
  }

  return newState
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    //get highest offer
    case `${HIGHEST_OFFER_FETCH}${PROMISE_PENDING}`:
      return { ...state, highestOffer: { ...state.highestOffer, isFetch: true }}
    case `${HIGHEST_OFFER_FETCH}${PROMISE_FULFILLED}`: { 
      const { data, status_code, message } = action.payload;
      return { ...state, highestOffer: { ...state.highestOffer, data, status_code, message, isFetch: false, error: null }}
    }
    case `${HIGHEST_OFFER_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, highestOffer: { ...state.highestOffer, ...error(action.payload), isFetch: false }}
    }

    //validate to enter the bid
    case `${VALIDATE_OFFER}${PROMISE_PENDING}`:
      return { ...state, validateOffer: { ...state.validateOffer, isFetch: true }}
    case `${VALIDATE_OFFER}${PROMISE_FULFILLED}`: { 
      const { data, status_code, message } = action.payload;
      return { ...state, validateOffer: { ...state.validateOffer, data, status_code, message, isFetch: false, error: null }}
    }
    case `${VALIDATE_OFFER}${PROMISE_REJECTED}`: {
      return { ...state, validateOffer: {...state.validateOffer, ...error(action.payload), isFetch: false }}
    }

    //submit offer
    case `${USER_OFFER_POST}${PROMISE_PENDING}`:
      return { ...state, submitOffer: { ...state.submitOffer, isSubmit: true, error: null }}
    case `${USER_OFFER_POST}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, submitOffer: { ...state.submitOffer, data, status_code, message, isSubmit: false, error: null }}
    }
    case `${USER_OFFER_POST}${"_RESET"}`: {
      return {...state, submitOffer: { data: null, error: null, isSubmit: false, status_code: 0, message: "" }}
    }
    case `${USER_OFFER_POST}${PROMISE_REJECTED}`:
      return { ...state, submitOffer: { ...state.submitOffer, ...error(action.payload), isSubmit: false }}

    //offer history list (user)
    case `${USER_OFFER_HISTORY_LIST}${PROMISE_PENDING}`:
      return { ...state, offerHistory: { ...state.offerHistory, isFetch: true }}
    case `${USER_OFFER_HISTORY_LIST}${PROMISE_FULFILLED}`:
      return (offerHistory(state, action.payload));
    case `${USER_OFFER_HISTORY_LIST}${PROMISE_REJECTED}`: { 
      return { ...state, offerHistory: { ...state.offerHistory, ...error(action.payload), isFetch: false }}
    }

    //offer pending list (user)
    case `${USER_OFFER_PENDING_LIST}${PROMISE_PENDING}`:
      return { ...state, offerPending: { ...state.offerPending, isFetch: true}}
    case `${USER_OFFER_PENDING_LIST}${PROMISE_FULFILLED}`: 
      return (offerPending(state, action.payload));
    case `${USER_OFFER_PENDING_LIST}${PROMISE_REJECTED}`: {
      return { ...state, offerPending: { ...state.offerPending, ...error(action.payload), isFetch: false}}
    }

    //offer accepted list (user)
    case `${USER_OFFER_ACCEPTED_LIST}${PROMISE_PENDING}`:
      return { ...state, offerAccepted: { ...state.offerAccepted, isFetch: true}}
    case `${USER_OFFER_ACCEPTED_LIST}${PROMISE_FULFILLED}`: 
      return (offerAccepted(state, action.payload));
    case `${USER_OFFER_ACCEPTED_LIST}${PROMISE_REJECTED}`: {
      return { ...state, offerAccepted: { ...state.offerAccepted, ...error(action.payload), isFetch: false}}
    }

    //offer details
    case `${USER_OFFER_DETAILS_FETCH}${PROMISE_PENDING}`:
      return { ...state, offerDetails: {...state.offerDetails, isFetch: true }}
    case `${USER_OFFER_DETAILS_FETCH}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, offerDetails: { ...state.offerDetails, data, status_code, message, isFetch: false, error: null }}
      }
    case `${USER_OFFER_DETAILS_FETCH}${PROMISE_REJECTED}`: {
      return { ...state, offerDetails: { ...state.offerDetails, ...error(action.payload), isFetch: false }}
    }

    //pending offer list new sneaker
    case `${PENDING_OFFER_LIST_NEW}${PROMISE_PENDING}`:
      return { ...state, pendingListNew: { ...state.pendingListNew, isSubmit: true } }
    case `${PENDING_OFFER_LIST_NEW}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, pendingListNew: { ...state.pendingListNew, data, status_code, message, isSubmit: false, error: null } }
    }
    case `${PENDING_OFFER_LIST_NEW}${PROMISE_REJECTED}`:
      return { ...state, pendingListNew: { ...state.pendingListNew, ...error(action.payload), isSubmit: false } }

    //pending offer list
    case `${PENDING_OFFER_LIST}${PROMISE_PENDING}`:
      return { ...state, pendingList: { ...state.pendingList, isFetch: true } }
    case `${PENDING_OFFER_LIST}${PROMISE_FULFILLED}`: {
      return (pendingList(state, action.payload));

      // const { data, status_code, message } = action.payload;
      // return { ...state, pendingList: { ...state.pendingList, data, status_code, message, isFetch: false, error: null } }
      
      // const newData = { ...data, data: [ ...data.data, ...data.data, ...data.data, ...data.data, ...data.data, ...data.data ] };
      // return { ...state, pendingList: { ...state.pendingList, data: newData, status_code, message, isFetch: false, error: null } }
    }
    case `${PENDING_OFFER_LIST}${PROMISE_REJECTED}`:{
      const error = { ...error(action.payload) };
      if(error.status_code === 404)
        return { ...state, pendingList: { ...state.pendingList, data: [], ...error, isFetch: false } }
      return { ...state, pendingList: { ...state.pendingList, ...error(action.payload), isFetch: false } }
    }

    //accept offer request
    case `${ACCEPT_OFFER_REQUEST}${PROMISE_PENDING}`:
      return { ...state, acceptOffer: { ...state.acceptOffer, isSubmit: true } }
    case `${ACCEPT_OFFER_REQUEST}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      return { ...state, acceptOffer: { ...state.acceptOffer, data, status_code, message, isSubmit: false, error: null } }
    }
    case `${ACCEPT_OFFER_REQUEST}${PROMISE_REJECTED}`:
      return { ...state, acceptOffer: { ...state.acceptOffer, ...error(action.payload), isSubmit: false } }

    //update offer user
    case `${UPDATE_OFFER_USER}${PROMISE_PENDING}`:
      return { ...state, updatedOffer: {...state.updatedOffer, isSubmit: true, error: null}}
    case `${UPDATE_OFFER_USER}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      const newData=[{...data}];
      return { ...state, updatedOffer: {...state.updatedOffer, status_code, message, isSubmit: false, error: null, data}, offerHistory: {...state.offerHistory, data: newData, status_code, message, isFetch: false, error: null}}
    }
    case `${UPDATE_OFFER_USER}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return{...state, updatedOffer: {...state.updatedOffer, isSubmit: false, ...error(action.payload), status_code, message}}
    }
    case `${UPDATE_OFFER_USER}_SET_DEFAULT`: {
      const { data, status_code, message } = action.payload;
      return { ...state, updatedOffer: {...state.updatedOffer, status_code, message, isSubmit: false, error: null, data}}
    }

    //delete offer user
    case `${DELETE_OFFER_USER}${PROMISE_PENDING}`:
      return { ...state, updatedOffer: { ...state.updatedOffer, isSubmit: true}}
    case `${DELETE_OFFER_USER}${PROMISE_FULFILLED}`: {
      const { data, status_code, message } = action.payload;
      const newData=[{...data}];
      return { ...state, updatedOffer: {...state.updatedOffer, status_code, message, isSubmit: false, error: null}, offerHistory: {...state.offerHistory, data: newData, status_code, message, isFetch: false, error: null}}
    }
    case `${DELETE_OFFER_USER}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return{...state, updatedOffer: {...state.updatedOffer, isSubmit: false, ...error(action.payload), status_code, message}}
    }

    //fetch max amount offer
    case `${FETCH_MAX_AMOUNT}${PROMISE_PENDING}`:
      return { ...state, maxAmount: { ...state.maxAmount, isFetch: true}}
    case `${FETCH_MAX_AMOUNT}${PROMISE_FULFILLED}`: { 
      const { data, status_code, message } = action.payload;
      return { ...state, maxAmount: { ...state.maxAmount, data, status_code, message, isFetch: false, error: null }}
    }
    case `${FETCH_MAX_AMOUNT}${PROMISE_REJECTED}`: {
      return { ...state, maxAmount: { ...state.maxAmount, ...error(action.payload), isFetch: false }}
    }
    case `${FETCH_BID_VALIDATION}${PROMISE_PENDING}`:
      return { ...state, bidValidation: { ...state.bidValidation, isFetch: true}}
    case `${FETCH_BID_VALIDATION}${PROMISE_FULFILLED}`: { 
      const { data, status_code, message } = action.payload;
      return { ...state, bidValidation: { ...state.bidValidation, data, status_code, message, isFetch: false, error: null }}
    }
    case `${FETCH_BID_VALIDATION}${PROMISE_REJECTED}`: {
      const { status_code, message } = action.payload.response.data.error;
      return { ...state, bidValidation: { ...state.bidValidation, ...error(action.payload), isFetch: false, message, status_code }}
    }

    default:
      return state;
  }
}

export default reducer;